import { HttpResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { Order, OrdersTotalResponse } from 'graphql-api/baskets-api-interfaces';

import { actionsPrefix } from '../prefix';

const ordersActionsPrefix = `${actionsPrefix}[Orders]`;

export const selectOrderId = createAction(
  `${ordersActionsPrefix} Select order id`,
  props<{ id: string }>(),
);

export const deselectOrderId = createAction(
  `${ordersActionsPrefix} Deselect order id`,
  props<{ id: string }>(),
);

export const loadOrders = createAction(`${ordersActionsPrefix} Load Orders`);

export const loadOrdersSuccess = createAction(
  `${ordersActionsPrefix} Load Orders Success`,
  props<{ orders: Order[]; totals: OrdersTotalResponse; afterKey: string }>(),
);

export const loadOrdersFailure = createAction(
  `${ordersActionsPrefix} Load Orders Failure`,
  props<{ error: string }>(),
);

export const exportOrders = createAction(
  `${ordersActionsPrefix} Export orders`,
);

export const exportOrdersResponse = createAction(
  `${ordersActionsPrefix} Export orders Response`,
  props<{ response: HttpResponse<string> }>(),
);

export const exportOrdersSuccess = createAction(
  `${ordersActionsPrefix} Export orders success`,
);

export const exportOrdersFailure = createAction(
  `${ordersActionsPrefix} Export orders failure`,
  props<{ error: string }>(),
);

export const exportAllOrders = createAction(
  `${ordersActionsPrefix} Export all orders`,
);

export const exportAllOrdersSuccess = createAction(
  `${ordersActionsPrefix} Export all orders success`,
);

export const exportAllOrdersFailure = createAction(
  `${ordersActionsPrefix} Export all orders failure`,
  props<{ error: string }>(),
);

export const resetOrdersState = createAction(
  `${ordersActionsPrefix} Reset orders state`,
);

export const increaseOrderBookPageNumber = createAction(
  `${ordersActionsPrefix} Increase Page Number`,
);

export const increasePageNumberSuccess = createAction(
  `${ordersActionsPrefix} Increase Page Number Success`,
  props<{ orders: Order[]; afterKey: string }>(),
);

export const increasePageNumberFailure = createAction(
  `${ordersActionsPrefix} Increase Page Number Failure`,
  props<{ error?: string }>(),
);
